var f;
const F = function() {
  if (f)
    return f;
  var u = "[a-fA-F\\d:]", o = function(a) {
    return a && a.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(u, ")|(?<=").concat(u, ")(?=\\s|$))") : "";
  }, n = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", c = "[a-fA-F\\d]{1,4}", r = [
    "(?:".concat(c, ":){7}(?:").concat(c, "|:)"),
    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
    "(?:".concat(c, ":){6}(?:").concat(n, "|:").concat(c, "|:)"),
    // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::
    "(?:".concat(c, ":){5}(?::").concat(n, "|(?::").concat(c, "){1,2}|:)"),
    // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::
    "(?:".concat(c, ":){4}(?:(?::").concat(c, "){0,1}:").concat(n, "|(?::").concat(c, "){1,3}|:)"),
    // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::
    "(?:".concat(c, ":){3}(?:(?::").concat(c, "){0,2}:").concat(n, "|(?::").concat(c, "){1,4}|:)"),
    // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::
    "(?:".concat(c, ":){2}(?:(?::").concat(c, "){0,3}:").concat(n, "|(?::").concat(c, "){1,5}|:)"),
    // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::
    "(?:".concat(c, ":){1}(?:(?::").concat(c, "){0,4}:").concat(n, "|(?::").concat(c, "){1,6}|:)"),
    // 1::              1::3:4:5:6:7:8   1::8            1::
    "(?::(?:(?::".concat(c, "){0,5}:").concat(n, "|(?::").concat(c, "){1,7}|:))")
    // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
  ], d = "(?:%[0-9a-zA-Z]{1,})?", t = "(?:".concat(r.join("|"), ")").concat(d), x = new RegExp("(?:^".concat(n, "$)|(?:^").concat(t, "$)")), g = new RegExp("^".concat(n, "$")), i = new RegExp("^".concat(t, "$")), e = function(a) {
    return a && a.exact ? x : new RegExp("(?:".concat(o(a)).concat(n).concat(o(a), ")|(?:").concat(o(a)).concat(t).concat(o(a), ")"), "g");
  };
  e.v4 = function(a) {
    return a && a.exact ? g : new RegExp("".concat(o(a)).concat(n).concat(o(a)), "g");
  }, e.v6 = function(a) {
    return a && a.exact ? i : new RegExp("".concat(o(a)).concat(t).concat(o(a)), "g");
  };
  var w = "(?:(?:[a-z]+:)?//)", p = "(?:\\S+(?::\\S*)?@)?", s = e.v4().source, v = e.v6().source, z = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", E = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", R = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", $ = "(?::\\d{2,5})?", l = '(?:[/?#][^\\s"]*)?', A = "(?:".concat(w, "|www\\.)").concat(p, "(?:localhost|").concat(s, "|").concat(v, "|").concat(z).concat(E).concat(R, ")").concat($).concat(l);
  return f = new RegExp("(?:^".concat(A, "$)"), "i"), f;
};
export {
  F as default
};
//# sourceMappingURL=url.mjs.map
